var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('img',{class:_vm.imageClass,attrs:{"src":"/img/roatel_logo_next.svg","alt":"Roatel Logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }